import { useEffect, useState } from "react";
import { api, formatBRL, formatDateBR } from "../../lib/api";
import { Plus, Trash2, FileText } from "lucide-react";
import { toast } from "sonner";

const empty = { client_id: "", plan_id: "", title: "", body: "Contrato padrão VM Corporate.", start_date: "", end_date: "", monthly_value: 0 };

export default function Contratos() {
  const [items, setItems] = useState([]);
  const [clients, setClients] = useState([]);
  const [plans, setPlans] = useState([]);
  const [form, setForm] = useState(empty);
  const [showForm, setShowForm] = useState(false);

  const load = () => Promise.all([
    api.get("/contracts").then(r => setItems(r.data)),
    api.get("/clients").then(r => setClients(r.data)),
    api.get("/plans").then(r => setPlans(r.data)),
  ]);
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/contracts", { ...form, monthly_value: +form.monthly_value, plan_id: form.plan_id || null, end_date: form.end_date || null });
      toast.success("Contrato criado");
      setShowForm(false);
      setForm(empty);
      load();
    } catch (err) { toast.error("Erro"); }
  };

  const remove = async (id) => { if (!confirm("Remover contrato?")) return; await api.delete(`/contracts/${id}`); load(); };

  return (
    <div data-testid="admin-contratos">
      <div className="admin-page-header">
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-[#D4AF37] font-semibold mb-2">Contratos</div>
          <h1 className="font-display text-2xl sm:text-3xl text-[#14213D] font-light">Gestão de Contratos</h1>
        </div>
        <button onClick={() => setShowForm(!showForm)} className="w-full sm:w-auto bg-[#14213D] text-white px-5 py-2.5 rounded-md text-sm font-semibold inline-flex items-center justify-center gap-2" data-testid="new-contract-btn">
          <Plus size={16} /> Novo Contrato
        </button>
      </div>

      {showForm && (
        <form onSubmit={create} className="bg-white border border-gray-200 rounded-lg p-6 mb-6 grid grid-cols-1 md:grid-cols-2 gap-3" data-testid="contract-form">
          <select required value={form.client_id} onChange={(e) => setForm({ ...form, client_id: e.target.value })} className="border border-gray-200 rounded px-3 py-2 text-sm">
            <option value="">Cliente *</option>
            {clients.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
          <select value={form.plan_id} onChange={(e) => setForm({ ...form, plan_id: e.target.value })} className="border border-gray-200 rounded px-3 py-2 text-sm">
            <option value="">Plano (opcional)</option>
            {plans.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
          <input required placeholder="Título *" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="border border-gray-200 rounded px-3 py-2 text-sm md:col-span-2" />
          <input required type="date" value={form.start_date} onChange={(e) => setForm({ ...form, start_date: e.target.value })} className="border border-gray-200 rounded px-3 py-2 text-sm" />
          <input type="date" placeholder="Término (opcional)" value={form.end_date} onChange={(e) => setForm({ ...form, end_date: e.target.value })} className="border border-gray-200 rounded px-3 py-2 text-sm" />
          <input required type="number" step="0.01" placeholder="Valor mensal *" value={form.monthly_value} onChange={(e) => setForm({ ...form, monthly_value: e.target.value })} className="border border-gray-200 rounded px-3 py-2 text-sm md:col-span-2" />
          <textarea rows={4} value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} className="border border-gray-200 rounded px-3 py-2 text-sm md:col-span-2" />
          <button type="submit" className="bg-[#D4AF37] text-[#14213D] font-semibold py-2.5 rounded text-sm md:col-span-2" data-testid="save-contract">Salvar</button>
        </form>
      )}

      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        <div className="table-wrap">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left text-xs uppercase tracking-wider text-gray-500 font-semibold">
            <tr>
              <th className="px-5 py-3">Cliente</th>
              <th className="px-5 py-3">Título</th>
              <th className="px-5 py-3">Vigência</th>
              <th className="px-5 py-3">Valor</th>
              <th className="px-5 py-3">Status</th>
              <th className="px-5 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={6} className="px-5 py-10 text-center text-gray-400">Nenhum contrato</td></tr>}
            {items.map((c) => (
              <tr key={c.id} className="border-t border-gray-100 hover:bg-gray-50" data-testid={`contract-${c.id}`}>
                <td className="px-5 py-3 font-semibold text-[#14213D]">{c.client_name}</td>
                <td className="px-5 py-3 text-gray-700 flex items-center gap-2"><FileText size={13} className="text-[#D4AF37]" />{c.title}</td>
                <td className="px-5 py-3 text-gray-600 text-xs">{formatDateBR(c.start_date)} → {c.end_date ? formatDateBR(c.end_date) : "indeterminado"}</td>
                <td className="px-5 py-3 font-semibold text-[#14213D]">{formatBRL(c.monthly_value)}/mês</td>
                <td className="px-5 py-3"><span className="text-[11px] px-2 py-0.5 rounded-full uppercase tracking-wider font-semibold bg-emerald-50 text-emerald-700">{c.status}</span></td>
                <td className="px-5 py-3"><button onClick={() => remove(c.id)} className="text-red-600 hover:bg-red-50 rounded p-1.5" data-testid={`del-contract-${c.id}`}><Trash2 size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
